angular.module("mercury.modules.stock.stockreceived", []);
